import { useState, useEffect } from 'react'
import axios from '@fs/zion-axios'

// Store for dynamic query parameters
let dynamicQueryParams = ''
let queryParamsVersion = 0
const listeners = new Set()

export function setDynamicQueryParams(params) {
  dynamicQueryParams = params
  queryParamsVersion += 1
  // Notify all listeners that the query params have changed
  listeners.forEach((listener) => listener(queryParamsVersion))
}

export default function useDynamicNavigation(dynamicLinksOn) {
  const [state, setState] = useState({ isLoading: true, isError: false })
  const [queryVersion, setQueryVersion] = useState(queryParamsVersion)

  // Subscribe to query params changes
  useEffect(() => {
    const listener = (newVersion) => {
      setQueryVersion(newVersion)
    }
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }, [])

  useEffect(() => {
    let mounted = true
    if (!dynamicLinksOn) {
      setState({ isLoading: false, isError: false })
    } else {
      setState({ isLoading: true, isError: false })
      getDynamicLinks()
        .then(({ header, account: accountArray }) => {
          if (mounted) {
            let account = null
            if (accountArray?.length) {
              account = accountArray[0]
            }
            setState({ isLoading: false, isError: false, headerNavigation: header, accountNavigation: account })
          }
        })
        .catch((error) => {
          console.error(error)
          if (mounted) {
            setState({ isLoading: false, isError: true })
          }
        })
    }
    return () => {
      mounted = false
    }
  }, [dynamicLinksOn, queryVersion])
  return state
}

// exported for tests
export function getDynamicLinks() {
  const baseUrl = '/service/home/utils/chef/header'
  const url = dynamicQueryParams ? `${baseUrl}?${dynamicQueryParams}` : baseUrl
  return axios.get(url).then((response) => response.data)
}
